import KeywordAssembler from './components/KeywordAssembler';

const App = () => {
  return (
    <div className="app">
      <header className="app-header">
        <div className="app-badge">Google Ads</div>
        <h1 className="app-title">Keyword <em>Builder</em></h1>
        <p className="app-subtitle">
          Generate every keyword combination automatically — across all match types,
          ready to copy into Google Ads.
        </p>
      </header>

      <div className="app-instructions">
        <div className="instruction-item">
          <span className="instruction-num">01</span>
          <span>Enter words or phrases in each column, one per line</span>
        </div>
        <div className="instruction-item">
          <span className="instruction-num">02</span>
          <span>Toggle columns as optional to include empty-slot combinations</span>
        </div>
        <div className="instruction-item">
          <span className="instruction-num">03</span>
          <span>Copy keywords in any match type format</span>
        </div>
      </div>

      <KeywordAssembler colCount='5' />
    </div>
  );
}

export default App;
